export default __webpack_public_path__ + "static/media/1794.ed35ac25.png";